// Image load error
export const imageLoadSuccess = e => e.target.classList.remove('hide')


export default imageLoadSuccess